import { useEffect, useState } from "react"
import { BaseNavbarController } from "./BaseNavbarController"
import './BaseNavbar.scss'
import * as CapitalizeLettersHelper from '../helpers/CapitalizeLettersHelper'
import {
    useNavigate,useParams
} from 'react-router-dom';
import VariablesEnum from "../enums/VariablesEnum";
export interface BaseNavbarProps { }
export interface BaseNavbarState {
    sideNavOpen: boolean
    workerResponse?: []
    activeMenu:""
}

var defaultState: BaseNavbarState = {
    sideNavOpen: false,
    workerResponse: [],
    activeMenu:""
}
var innerState: BaseNavbarState = { ...defaultState }
var controller = new BaseNavbarController()

const BaseNavbar: React.FC<BaseNavbarProps> = (props: BaseNavbarProps) => {
    let { id } = useParams();
    const getState = () => {
        return { ...innerState }
    }
    const setState = (partialState: any, overwrite?: boolean) => {
        if (overwrite) {
            innerState = { ...partialState }
        } else {
            innerState = { ...innerState, ...partialState }
        }
        setComponentState(innerState)
    }

    const [componentState, setComponentState] = useState<BaseNavbarState>(innerState)
    console.log("componentState", componentState);

    controller.config(setState, getState, () => defaultState, props as any)

    useEffect(() => {
        controller.initialize()
        if(id==undefined) {
            setState({activeMenu:""})
        }else{
            setState({activeMenu:id})
        }
        
    }, [])
    const navigate = useNavigate();

    /* Redirection */
    function redirectToWorkerDetailsHandler(e: any) {
        //console.log('onclick',e.target.id);
        e.preventDefault();
        setState({activeMenu:e.target.id})
        navigate(`/worker-details/${e.target.id}/details`);
        controller.toggleClickHandler()
    }

    function redirectToHomeDetailsHandler(e: any) {
        e.preventDefault();
        setState({activeMenu:""})
        navigate(`/home`);
        controller.toggleClickHandler()
    }

    /* Workers Job Title */
    const renderWorkersJobTitleControls = () => {
        return (
            <>
                <div className='d-flex justify-content-between align-items-center navbar-contains-second'>
                    <div className={"second-navbar-show " + (getState().sideNavOpen ? 'slideOff' : 'slideOn')}>
                        <div className="d-flex justify-content-between align-items-center">
                            <ul className="menu-list-layout">
                                
                                {getState().workerResponse && getState().workerResponse!.length > 0 &&
                                    getState().workerResponse!.map((itm: any, index: number) => {
                                        return (
                                            <li role="button"  id={itm.id} className={getState().activeMenu==itm.id ? 'position-relative active': 'position-relative'} onClick={redirectToWorkerDetailsHandler} key={index.toString()} >
                                                {CapitalizeLettersHelper.capitalizeWords(itm.workerJobTitle)}
                                            </li>
                                        )
                                    })}
                                <li className={getState().activeMenu=="" ? 'position-relative active': 'position-relative'} role="button" onClick={redirectToHomeDetailsHandler}>
                                    {VariablesEnum.HOME}
                                </li>
                                <img onClick={() => controller.toggleClickHandler()} className="arrow-left-layout" src="/image/right-arrow.svg" alt="Right Arrow" />
                            </ul>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    /*  Trades Lines */
    const renderTradesLinesControls = () => {
        return (
            <>
                <div className='navbar-contains-layout'>
                    <div className="first-navbar-show">
                        <div className="top-header-layout d-flex justify-content-between align-items-center">
                            <a href={VariablesEnum.ABSOLUTE_URL}>
                                <img className="position-relative mr-3" src="/image/logo-arrow.png" alt="Left Arrow" />
                            </a>
                            <a href={VariablesEnum.ABSOLUTE_URL} className="link-top">
                                <p className="logo-caption-title m-0 ms-3">{VariablesEnum.RETURN_TO} <b className="d-none d-sm-inline-block">{VariablesEnum.TITLE}</b><b className="d-inline-block d-sm-none">{VariablesEnum.MOBILETITLE}</b></p>
                            </a>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="mb-0 mr-2 menu-title d-none d-sm-inline-block">{VariablesEnum.MENU}</p>
                            <button className={"p-0 m-0 menu-button " + (getState().sideNavOpen ? 'menu-buttoneOn' : 'menu-buttonOff')} onClick={() => controller.toggleClickHandler()}>
                                <img className="x-1" src="/image/line-bg.svg" alt="Menu" />
                                <img className="x-2" src="/image/line-bg.svg" alt="Menu" />
                                <img className="x-3" src="/image/line-bg.svg" alt="Menu" />
                                <img className="x-4" src="/image/line-bg.svg" alt="Menu" />
                                <img className="x-5" src="/image/line-bg.svg" alt="Menu" />
                                <img className="x-6" src="/image/line-bg.svg" alt="Menu" />
                                <img className="x-7" src="/image/line-bg.svg" alt="Menu" />
                            </button>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    /* Trades with lines and Worker's with their job titles */
    const renderTradesControls = () => {
        return (
            <>
                <div className={"main-navbar-section " + (getState().sideNavOpen ? 'main-navbaropen' : 'main-navbarclose')}>
                    {renderWorkersJobTitleControls()}
                    {renderTradesLinesControls()}
                </div>
            </>
        )
    }

    /* Page layout */

    return (<>{renderTradesControls()} </>)

}

export default BaseNavbar

